export default {
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
    localStorage.setItem('permissions', JSON.stringify(permissions));
  }
}
